import {
  IRequestCases,
  initialCasesViewOptions
} from "src/share/types/case/searchCase";

export const isFiltering = (
  casesViewType: any,
  optionsRequest: IRequestCases
) => {
  return (
    JSON.stringify({ ...initialCasesViewOptions, ...casesViewType }) !==
    JSON.stringify(optionsRequest)
  );
};



// WEBPACK FOOTER //
// ./src/modules/Case/View/utils/isFiltering.ts